export const youtube = {
    search: 'https://www.googleapis.com/youtube/v3/search',
    activities: 'https://www.googleapis.com/youtube/v3/activities',
    videos: 'https://www.googleapis.com/youtube/v3/videos'
}

export const self = {
    videos: '/api/videos'
}
